import { render } from "./DetalleSolicitudesInspeccionComponent.vue?vue&type=template&id=71b73a9c"
import script from "./DetalleSolicitudesInspeccionComponent.vue?vue&type=script&lang=js"
export * from "./DetalleSolicitudesInspeccionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__